export default {
  data() {
    return {
      formHeight: 82,
    }
  },
  methods: {
    setFormHeight() {
      this.$nextTick(() => {
        const breadCrumbDoms = document.getElementsByClassName('el-breadcrumb')
        let breadCrumbHeight = 0
        if (breadCrumbDoms.length) {
          breadCrumbHeight = breadCrumbDoms[0].offsetHeight + 10
        }
        const formHeight = (this.$refs.formHeightRef && this.$refs.formHeightRef.offsetHeight) || 50
        this.formHeight = formHeight + breadCrumbHeight
      })
    },
  },
  mounted() {
    this.setFormHeight()
    window.addEventListener('resize', this.setFormHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setFormHeight)
  },
}
